export const socialLinks = {
  facebook: null,
  instagram: null,
  linkedin: null,
  site: null,
  tiktok: null,
  twitter: null,
  youtube: null,
};
